/* eslint-disable react/prop-types */
import { Alert } from 'antd';
import React from 'react';

import './style.scss';

const RestrictedAccessMessage = ({ message }) => (
  <div className="restricted-access-message">
    <Alert
      className="alert"
      message={message || "You don't have access to view/edit cost/selling price"}
      type="info"
      showIcon
    />
  </div>
);

export default RestrictedAccessMessage;
